import {
  Component,
  Input,
  OnInit,
  OnChanges,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { countryFlagsUrls } from '../../utils/country-flags-urls';
import { NodeService } from '../../services/node-service/node-service.service';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { PointOfInterest } from '../categories/categories.model';
import { Router } from '@angular/router';
import { DeleteConfirmComponent } from '../delete-confirm/delete-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { SubcategoryService } from '../subcategory/subcategory.service';
import { AppConfigService } from '../../auth/services/app-config.service';
import { formatDate } from '@angular/common';
import { ConfigService } from 'src/app/config.service';
import { GoogleMapsLoaderService } from 'src/app/services/google-maps-loader.service';

@Component({
  selector: 'app-parent-card',
  templateUrl: './parent-card.component.html',
  styleUrls: ['./parent-card.component.css'],
  standalone: false,
})
export class ParentCardComponent implements OnInit, OnChanges {
  @Input() parent!: any;
  @Input() data!: any;
  @Input() showSubCount: boolean = true;
  @ViewChildren(MapInfoWindow) infoWindowsView?: QueryList<MapInfoWindow>;

  center = { lat: 0, lng: 0 };
  zoom = 4;
  display?: google.maps.LatLngLiteral;
  pois: google.maps.LatLngLiteral[] = [];
  icon: google.maps.Symbol = {
    path: google.maps.SymbolPath.CIRCLE,
    scale: 3,
    fillColor: 'red',
  };
  poisList: PointOfInterest[] = [];

  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: this.icon,
  };
  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
  };
  catId!: number;
  readonly exportCsvUrl: string = `${this.appConfig.config.baseUrl}${this.appConfig.config.backendUrl}/report/csv?categoryid=`;

  constructor(
    private nodeService: NodeService,
    public router: Router,
    private subcategoryService: SubcategoryService,
    public dialog: MatDialog,
    private configService: ConfigService,
    private appConfig: AppConfigService,
    private googleMapsLoader: GoogleMapsLoaderService
  ) {}

  openDialogToDelete() {
    const dialogRef = this.dialog.open(DeleteConfirmComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.deleteCatClick();
    });
  }

  deleteCatClick(): void {
    this.subcategoryService.deleteCat(this.parent?.id).subscribe((res) => {
      if (this.parent?.parentId === null) {
        this.router.navigate(['/', 'categories']);
      } else {
        this.router.navigate(['/', 'category', this.parent?.parentId]);
      }
    });
  }

  ngOnInit(): void {
    this.nodeService.setParentSelected(this.parent?.category);
    this.generatePois();
    this.configService.getConfig().subscribe((res) => {
      this.googleMapsLoader.load(res.body.apiConfig).catch((error) => console.error(error));
    });
  }

  ngOnChanges(): void {
    this.generatePois();
  }

  getImage(name: any) {
    const { url } = countryFlagsUrls.filter(({ country }) => 'default' === country)[0];
    return url;
  }

  generatePois() {
    if (this.parent) {
      this.poisList = this.nodeService
        .getPois()
        .filter((pois) => pois.categoryId === this.parent?.id);

      if (this.poisList.length > 0) {
        this.center = { lat: this.poisList[0].lat!, lng: this.poisList[0].lng! };
      }
    }
  }

  openInfoWindow(marker: MapMarker, windowIndex: number) {
    let curIdx = 0;
    this.infoWindowsView?.forEach((window: MapInfoWindow) => {
      if (windowIndex === curIdx) {
        window.open(marker);
        curIdx++;
      } else {
        window.close();
        curIdx++;
      }
    });
  }

  generateRoute(id: number | null) {
    if (id === null) {
      this.router.navigate([`/categories`]);
    } else {
      this.router.navigate([`/category/${id}`]);
    }
  }

  setCategoryToEdit() {
    this.nodeService.setCategoryToEdit(this.parent);
  }

  redirectToParent(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/', 'category', this.parent?.parentId]);
  }

  iconErrorHandler(event: any) {
    event.target.src = this.appConfig.config.baseHref + this.appConfig.config.defaultIcon128;
  }

  markerErrorHandler(event: any) {
    event.target.src = this.appConfig.config.baseHref + this.appConfig.config.defaultMarker128;
  }

  exportCsv() {
    this.subcategoryService.exportCsv(this.parent?.id).subscribe((results) => {
      this.transformToCsv(results);
    });
  }

  transformToCsv(data: any) {
    let file = new Blob([data], { type: '.txt' });
    let a = document.createElement('a'),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = this.csvName();
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  csvOnClick() {
    this.exportCsv();
  }

  csvName(): string {
    const date = new Date();
    const stringDate = formatDate(date, 'dd-MM-yyyy', 'en-US', '-0400');
    return `Pois-${this.parent?.nombre}-${stringDate}.csv`;
  }
}
